<template>
<div class="chapter">
<div class="inner_page">
<a id="page_5"></a>
<p class="dedi1">To Rachel</p>
<p class="dedi2">In you, there are three women: the woman one first falls in love with, the woman one marries, and the woman one loves forever.</p>
<a id="page_6"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Dedication.vue?7b4156f6